import { isAnimalStyleAvatarGame } from '@airhead-games/shared/configs';
import { useRoomConfig } from '../../../hooks/useRoomConfig';

/** True when the room’s selected game is Feed The Farm (animal CDN avatars). */
export function useAnimalStyleAvatars(): boolean {
  const { gameConfig } = useRoomConfig();
  return isAnimalStyleAvatarGame(gameConfig?.gameId);
}
